var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24957 15.9999C7.18399 16.0007 7.11897 15.9877 7.05869 15.9619C6.99842 15.9361 6.94421 15.8979 6.89956 15.8499C6.85173 15.805 6.81361 15.7508 6.78755 15.6906C6.76149 15.6304 6.74805 15.5655 6.74805 15.4999C6.74805 15.4343 6.76149 15.3694 6.78755 15.3092C6.81361 15.249 6.85173 15.1947 6.89956 15.1499L12.0396 9.99986L6.89956 4.84986C6.80674 4.75703 6.75459 4.63113 6.75459 4.49986C6.75459 4.36858 6.80674 4.24268 6.89956 4.14986C6.99239 4.05703 7.11829 4.00488 7.24957 4.00488C7.38084 4.00488 7.50674 4.05703 7.59957 4.14986L13.0996 9.64986C13.1474 9.69475 13.1855 9.74897 13.2116 9.80916C13.2376 9.86936 13.2511 9.93426 13.2511 9.99986C13.2511 10.0655 13.2376 10.1304 13.2116 10.1906C13.1855 10.2508 13.1474 10.305 13.0996 10.3499L7.59957 15.8499C7.55492 15.8979 7.50071 15.9361 7.44044 15.9619C7.38016 15.9877 7.31514 16.0007 7.24957 15.9999Z",
    fill: "#9EA3AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGt);
export default __webpack_public_path__ + "static/media/gt.d6f3c2f3708752ed17b278ef241d64dc.svg";
export { ForwardRef as ReactComponent };